var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"his-info-institution-selector-root"},[_c('light-user-definition-dialog',{ref:"selector"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }